import axios from 'axios'
import logger from '@/utils/logger';

export default {
  getSignedURL (foldername,filename, filetype) {
    let endpoint = "https://msobclives3.s3.ap-south-1.amazonaws.com/v1/";
    
    //let endpoint = "https://4praudrnzg.execute-api.ap-south-1.amazonaws.com/prod/sgbfileupload/v1";
    let payload = {
      filePath: foldername.toLowerCase() +"/"+ filename,
      contentType: filetype
    }
    //console.log ("payload", payload);

    return axios.put(endpoint, payload)
      .then((res) => {
        return Promise.resolve(res.data.url || "/")
      })
      .catch((err) => {
        logger.error(err);
        return Promise.reject('/')
      })
  },
}


// WEBPACK FOOTER //
// ./src/apis/lambda.js